import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentOptionV2Component } from './payment-option-v2.component';
import { MatButtonModule } from '@angular/material/button';
import { PaymentSipCardModule } from '../payment-sip-card/payment-sip-card.module';
import { PaymentSipButtonModule } from '../payment-sip-button/payment-sip-button.module';
import { PaymentNetbankingModule } from '../payment-netbanking/payment-netbanking.module';
import { PaymentWalletModule } from '../payment-wallet/payment-wallet.module';
import { PaymentPreUsedModule } from '../payment-pre-used/payment-pre-used.module';
import { PaymentUpiModule } from '../payment-upi/payment-upi.module';
import { PaymentSipUpiTimerModule } from '../payment-sip-upi-timer/payment-sip-upi-timer.module';
import { QrcodeBoxModule } from '../qrcode-box/qrcode-box.module';
import { RecomendedPaymentOptionModule } from '../recomended-payment-option/recomended-payment-option.module';
import { PaymentSipUpiModule } from '../payment-sip-upi/payment-sip-upi.module';


@NgModule({
  declarations: [
    PaymentOptionV2Component
  ],
  exports: [
    PaymentOptionV2Component
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    PaymentSipCardModule,
    PaymentSipButtonModule,
    PaymentUpiModule,
    PaymentNetbankingModule,
    PaymentWalletModule,
    PaymentPreUsedModule,
    PaymentSipUpiTimerModule,
    QrcodeBoxModule,
    RecomendedPaymentOptionModule,
    PaymentSipUpiModule
  ]
})
export class PaymentOptionV2Module { }
